import type { ReactNode } from "react";

type Props = {
  children: ReactNode;
};

/**
 * Page-purpose copy under the title bar.
 * App Home / BFS: never put bare `s-paragraph` as a direct `s-page` child —
 * wrap in `s-section` (see shopify.dev Page examples).
 */
export function PageIntro({ children }: Props) {
  return (
    <s-section>
      <s-paragraph color="subdued">{children}</s-paragraph>
    </s-section>
  );
}
